import FuelingCardDTO from 'features/contracts/dtos/FuelingCardDTO';
import DateFormatter from 'features/shared/components/formatters/DateFormatter';
import React from 'react';

type Props = {
  card: FuelingCardDTO;
}

const FuelingCard = ({ card }: Props) => {
  // render
  return (
    <div className="row no-gutters align-items-center">
      <div className="col col-sm-6">
        <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
          {card.cardNumber}
        </div>
      </div>
      <div className="col col-sm-6 pl-3 text-muted">
        <div className="row no-gutters justify-content-end">
          <div className="col-auto col-sm-6 text-right text-sm-left">
            <DateFormatter date={card.dateFrom!} />
            <span className="d-sm-none mx-1">-</span>
          </div>
          <div className="col-auto col-sm-6 text-right">
            <DateFormatter date={card.dateTo!} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default FuelingCard;